import { Component, OnInit } from '@angular/core';
import { GetAccount, UpdateCurrentAccountId } from '@app/finxone-web-frontend/app/lib/actions/account.action';
import {
  ResetFormDataAction,
  UpdateFormDataActionWithId,
} from '@app/finxone-web-frontend/app/lib/actions/form-submission.action';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { AccountState, AccountStateModel } from '@app/finxone-web-frontend/app/lib/state/account.state';
import { RoleState, RoleStateModel } from '@app/finxone-web-frontend/app/lib/state/role.state';
import {
  removeDuplicateCurrencies,
  removeInvalidCurrencies,
  setNavigationUrl,
} from '@app/finxone-web-frontend/app/lib/utils/utils';
import { FormActionTypeEnum } from '@finxone-platform/form-action';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { AccountStatusType, DummyRole, ProviderClass } from '@finxone-platform/shared/sys-config-types';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject, map, takeUntil } from 'rxjs';
import { BaseAccountsListingComponent } from '../base/base-accounts-listing.component';

@Component({
  standalone: false,
  selector: 'finxone-web-frontend-bulk-payment-accounts-listing',
  templateUrl: './bulk-payment-accounts-listing.component.html',
})
export class BulkPaymentAccountsListingComponent extends BaseAccountsListingComponent implements OnInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  @Select(AccountState.getAccounts)
  private accountState$!: Observable<AccountStateModel>;
  @Select(RoleState.getRole)
  private role$!: Observable<RoleStateModel>;
  public totalListCount: number;
  public accountContextStatusList: AccountStatusType[];

  constructor(
    public override dataIn: ProviderClass<any>,
    public override store: Store,
    public override configService: ConfigService,
  ) {
    super(dataIn, store, configService);

    if (this.dataIn?.attri) {
      this.widgetConfig = this.dataIn.attri.widgetProperties;
      this.contextSwitch = this.dataIn.attri['contextSwitch'];
      this.accountContextStatusList = this.dataIn.attri?.['accountContextList']?.map(
        (item: { id: AccountStatusType }) => item.id,
      ) ?? [AccountStatusType.active];
      this.setNavigation();
    }

    this.getWidgetCssConfig();
    this.configService
      .getCurrencies()
      .pipe(
        takeUntil(this.destroy$),
        map((response) => {
          const validCurrencies = removeInvalidCurrencies(response);
          this.currencies = removeDuplicateCurrencies(validCurrencies, 'currency_code');
        }),
      )
      .subscribe();
  }

  ngOnInit(): void {
    this.store.dispatch(new GetAccount(this.pageNumber, this.pageSize, this.accountContextStatusList));
    this.accountState$
      .pipe(
        map((response) => {
          this.accountsInfo = response;
          this.totalPages = response.accountTotalPages;
          this.totalListCount = response.totalItems;
        }),
      )
      .subscribe();
    this.configService.getCountries().subscribe({
      next: (data) => {
        this.countries = data;
      },
    });
    this.store.dispatch(new ResetFormDataAction());
  }

  private setNavigation() {
    if (this.dataIn?.attri['role'] === DummyRole.EMPTY_ROLE) {
      this.role$
        .subscribe((roleInfo: { role: any }) => {
          this.dataIn.attri['role'] = roleInfo.role;
        })
        .unsubscribe();
    }

    if (this.dataIn.attri['navigationOption'] == 'use-as-navigation') {
      this.navigateToUrl = setNavigationUrl(this.dataIn);
    }
  }

  public updateFormSate(id: string) {
    this.store.dispatch(new UpdateCurrentAccountId(id));
    this.store.dispatch(
      new UpdateFormDataActionWithId(
        {
          selectedAccountId: id,
        },
        FormActionTypeEnum.BULK_PAYMENTS,
      ),
    );
  }
}
